import React from "react";
import ServiceDetailLayout from "./ServiceDetailLayout";
import { FiFileText } from "react-icons/fi";
import { useTranslation } from "react-i18next";

const FormAssistance = () => {
    const { t } = useTranslation();
    const description = t("service_pages.form_assistance.description");
    const features = t("service_pages.form_assistance.features", { returnObjects: true });
    const highlights = t("service_pages.form_assistance.highlights", { returnObjects: true });
    const steps = t("service_pages.form_assistance.steps", { returnObjects: true });
    const faqs = t("service_pages.form_assistance.faqs", { returnObjects: true });

    const structuredData = {
        "@context": "https://schema.org",
        "@type": "Service",
        name: "Immigration Form Assistance",
        description,
        provider: {
            "@type": "LocalBusiness",
            name: "Citizen Hub Immigration Services",
            telephone: "+1 3108802133",
            email: "info@citznhub.com",
        },
        areaServed: [
            "United States",
            "California",
            "New York",
            "Texas",
            "Florida",
        ],
    };

    // Create a simple icon-based image placeholder
    const IconPlaceholder = () => (
        <div className="w-full h-96 lg:h-[28rem] bg-gradient-to-br from-blue-500 to-indigo-600 rounded-2xl shadow-lg flex items-center justify-center">
            <FiFileText className="w-48 h-48 text-white opacity-80" />
        </div>
    );

    return (
        <ServiceDetailLayout
            title={t("service_pages.form_assistance.title")}
            subtitle={t("service_pages.form_assistance.subtitle")}
            description={description}
            features={features}
            highlights={highlights}
            steps={steps}
            faqs={faqs}
            imageSrc={null}
            imageAlt="Immigration form assistance"
            canonicalUrl="https://citizenhubimmigration.com/services/form-assistance"
            structuredData={structuredData}
            customImage={<IconPlaceholder />}
        />
    );
};

export default FormAssistance;
